const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class KnowledgeOfTheAncients extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.KnowledgeOfTheAncients,
            "Each civilzation scores 1 science for each completed wonder and gains 1 resource if it has an unfinished wonder. Double these rewards for Age A wonders.",
            {}
        )
    }
}

module.exports = KnowledgeOfTheAncients;